import { atom } from 'recoil';

const formInfoAtom = atom({
  key: 'form-info',
  default: {
    useAttachmentV2: false,
    isFormDisabled: false,
    isSendDisabled: false,
  },
});

export default formInfoAtom;
